var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-component",style:(_vm.getLoadingStyle())},[_c('img',{staticClass:"loading-logo",attrs:{"src":_vm.data.logos.short_logo}}),_c('div',{staticClass:"spinner-box"},[_c('b-spinner',{staticStyle:{"width":"35px","height":"35px"},attrs:{"variant":_vm.data.settings.spinner_variant}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }